import React from 'react';
import Applications from '../../../modules/Applications/components/Applications';

const ApplicationsPage = () => {
  return (
    <Applications />
  );
};

export default ApplicationsPage;